import React from "react";
import styled from "styled-components";
import ImgSrc from "../../assets/avatar-welcome.png";

const StyledImg = styled.img`
  margin: 38px auto 38px auto;
  width: 78px;
  //height: 189px;
`;

const AvatarImg = () => {
  return (
    <StyledImg
      className="ui image"
      alt="SafeFun Avatar"
      src={ImgSrc}
    ></StyledImg>
  );
};

export default AvatarImg;
